import React from 'react';
import { Search } from '@material-ui/icons';
import { useHistory } from 'react-router';
import { Datatable } from '../../../components';
import moment from 'moment';

export const AndromedaJobsTable = ({ data, title, loading }) => {
  const history = useHistory();

  const tableConfig = [
    {
      heading: 'Agent',
      key: 'agent',
      formatter: (val) => val, // link to agents page?
    },
    {
      heading: 'Participant Id',
      key: 'participantId',
      formatter: (val) => val,
    },
    {
      heading: 'Participant Name',
      key: 'participantName',
      formatter: (val) => val,
    },
    {
      heading: 'Type',
      key: 'type',
      formatter: (val) => val,
    },
    {
      heading: 'Started',
      key: 'started',
      formatter: (val) =>
        moment.utc(val).local().format('MM/DD/YYYY, h:mm:ss a'),
    },
    {
      heading: 'Finished',
      key: 'finished',
      formatter: (val) =>
        val ? moment.utc(val).local().format('MM/DD/YYYY, h:mm:ss a') : '',
    },
    {
      heading: 'Explore',
      key: 'id',
      formatter: (val) => (
        <Search
          color="primary"
          style={{ cursor: 'pointer' }}
          onClick={() =>
            history.push(`/dashboard/andromeda/job?id=${val}`, {
              job: data.find((x) => x.id === val),
            })
          }
        />
      ),
    },
  ];

  return (
    <Datatable
      loading={loading}
      tableHeading={title}
      tableConfig={tableConfig}
      data={data}
      defaultSortColumn={'agent'}
    />
  );
};
